import { useEffect, useState } from "react";
import { onGetauthuserNotifications } from "../services/audit";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { onAddNotification } from "../services/notifications";

export default () => {
  const [userNotifications, setuserNotifications] = useState([]);
  const { SelectedOrg } = useStateGetter();
  const { config } = useStateGetter();
  const getUserNotification = async () => {
    var res = await onGetauthuserNotifications(config);
    setuserNotifications(res.data);
  };

  const AddNotification = async (data: any) => {
    await Promise.all(
      data.users.map(async (user: any) => {
        const postdata = {
          message: data.message,
          userID: user.userID,
          organizationID: SelectedOrg.id, };
        var res = await onAddNotification(postdata, config);
      })
    );
  };

  useEffect(() => {
    getUserNotification();
  }, []);
  return { userNotifications, AddNotification };
};
